export function loader() {
  throw new Response('Not Found', { status: 404 })
}

// for website_visit and tracking events error to pass. we need to look into this.
export function action() {
  return null
}

export const meta = () => ({ title: `Career.io – 404 Not Found` })

const Component = () => <></>
export default Component
